// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const Search = createSvgIcon(
  <React.Fragment><circle cx="6.5" cy="6.5" r="5.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 15l-4.5-4.5" /></React.Fragment>,
  'small'
);
